export default __webpack_public_path__ + "static/media/bg-modal-executive.d1d3f15b.svg";